const capitalize = name => name.charAt(0).toUpperCase() + name.slice(1);

export default capitalize;
